import { IBuyAndHoldParams, IBuyParams, IPackage } from '../types';
import {
  IProlongAndHoldSubscriptionParameters,
  IProlongSubscriptionParameters,
  prolongAndHoldSubscription,
  prolongSubscription,
} from '../../../services';
import { TAppState } from '../../../types';
import { selectProlongSubscriptionParameters } from '../../../selectors';

export class Subscription implements IPackage<IProlongSubscriptionParameters> {
  public async buy(params: IBuyParams<IProlongSubscriptionParameters>) {
    return prolongSubscription(params);
  }

  public async buyWithHold(params: IBuyAndHoldParams<IProlongAndHoldSubscriptionParameters>) {
    return prolongAndHoldSubscription(params);
  }

  public getParams(state: TAppState) {
    return selectProlongSubscriptionParameters(state);
  }

  public trackCancel(): void {}

  public trackConfirm(): void {}
}
